export default "__VITE_ASSET__DUSZVym0__"